import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ResultGetPaged, filterBy } from 'pmv-common';
import { convocacaoDeficiente } from '../models/convocacao-deficiente.model';
import { ConvocacaoDeficienteFilter } from '../models/convocacao-deficiente-filter';
import { saveAs } from 'file-saver';

@Injectable()
export class ConvocacaoDeficienteService {

  constructor(private httpClient: HttpClient) { }

  Create(convocacao: convocacaoDeficiente): Observable<convocacaoDeficiente> {
    return this.httpClient.post<convocacaoDeficiente>(`Convocacao/PostConvocacaoDef/`, convocacao);
  }

  GetConvocacoes(page?: number, itemsPerPage?: number, filter?: ConvocacaoDeficienteFilter): Observable<ResultGetPaged<convocacaoDeficiente>> {
    filter.pg = page;
    filter.itensPg = itemsPerPage;
    return this.httpClient.post<ResultGetPaged<convocacaoDeficiente>>('/Convocacao/GetConvocacoesDef', filter);
  }

  Delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`/Convocacao/DeleteConvocacoesDef/${id}`);
  }

  homologar(id: number): Observable<void> {
    return this.httpClient.post<void>(`/Convocacao/PostHomologacaoDef`, id);
  }

  EnviarEmail(id: number): Observable<boolean> {
    return this.httpClient.post<boolean>(`/Convocacao/PostEnviarEmail`, id);
  }

  ValidaEnvioEmail(id: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`/Convocacao/GetValidaEnvioEmailDef/${id}`);
  }
  
  ValidaConvocacao(concurso: number): Observable<boolean> {
    return this.httpClient.get<boolean>(`/Convocacao/GetValidaConvocacaoDef/${concurso}`);
  }

  GerarRelatorioEdital(codEditalDef: number) {
    this.httpClient.get(filterBy(codEditalDef, `Report/GetEditalConvocacaoDef/${codEditalDef}`),
      { responseType: 'blob' }
    ).subscribe(relatorio => {
      const dataAtual = new Date().toISOString();
      const nomeArquivo = `edital-${dataAtual}.pdf`;
      saveAs(relatorio, nomeArquivo);
    }, error => {
      console.error(error);
      throw error;
    });
  }
  GerarRelatorioResultado(codEditalDef: number) {
    this.httpClient.get(filterBy(codEditalDef, `Report/GetResultadoAvaliacaoDef/${codEditalDef}`),
      { responseType: 'blob' }
    ).subscribe(relatorio => {
      const dataAtual = new Date().toISOString();
      const nomeArquivo = `resultado-avaliacao-${dataAtual}.pdf`;
      saveAs(relatorio, nomeArquivo);
    }, error => {
      console.error(error);
      throw error;
    });
  }

  
}




// WEBPACK FOOTER //
// ./src/app/services/convocacao-deficiente.service.ts